import Backbone from 'backbone';
import SocialProfile from 'models/user/UserProfile';
import { isReadonlyMode, isProductSupportMode, isRaceManagementMode } from 'system/SystemUtil';

let globalSocialProfileObject;

if (
    (isReadonlyMode() || isProductSupportMode() || isRaceManagementMode()) &&
    !location.pathname.includes('delegation-authorization')
) {
    globalSocialProfileObject = new SocialProfile(JSON.parse(localStorage.getItem('viewerSocialProfile')));
} else {
    if (window.VIEWER_SOCIAL_PROFILE) {
        globalSocialProfileObject = new SocialProfile(window.VIEWER_SOCIAL_PROFILE);
        delete window.VIEWER_SOCIAL_PROFILE;
    } else {
        // This can be undefined for unathenticated user viewing a public page.  Use the default model.
        globalSocialProfileObject = new SocialProfile();
    }
}

export default globalSocialProfileObject;
